module.exports = __webpack_public_path__ + "static/media/nintendo_logo_b&w.297ed6e7.png";